import React from 'react'

import { LntTag } from '@app/components/base'

import { TAG_TYPE } from '@app/constants/tag'

import { PRODUCT_PRICING_STATES } from '@app/api/constants'
import { PRODUCT_PRICING_STATES_TITLE } from '@app/pages/TransferResultsPage/constants'

import { ObjectValuesType } from '@app/types'

import type { LntTagType } from '@app/components/base/Tag/types'

type StateType = ObjectValuesType<typeof PRODUCT_PRICING_STATES> | null

const matchStateToTagType = (status: ObjectValuesType<typeof PRODUCT_PRICING_STATES> | null): LntTagType => {
  switch (status) {
    case PRODUCT_PRICING_STATES.DONE:
      return TAG_TYPE.success

    case PRODUCT_PRICING_STATES.PROCESSING:
      return TAG_TYPE.primary

    default:
      return TAG_TYPE.default
  }
}

const stateToTagText = (state: StateType): string => {
  if (!state) return 'Не определен'

  return PRODUCT_PRICING_STATES_TITLE[state]
}

export const PricingProductStateTagRender: React.FC<{ state: StateType }> = ({ state }) => {
  const type = matchStateToTagType(state)
  const stateText = stateToTagText(state)

  return <LntTag type={ type }>{ stateText }</LntTag>
}
